import { useMutation } from '@tanstack/react-query';

import { useRequest } from '@frontend/api';
import type { MutationFunction } from '@frontend/api/src/common/queryFunction';

import type { ExecuteImportData, ExecuteImportQueryVars } from './types';

export const useExecuteImport: MutationFunction<
  ExecuteImportData,
  ExecuteImportQueryVars
> = ({ query, requestOptions, queryOptions } = {}) => {
  const request = useRequest(requestOptions);

  return useMutation({
    mutationFn: (requestData) => {
      const { quoteId } = requestData;
      const urlPath = `/quotes/${quoteId}/import_historical_work`;
      return request<ExecuteImportData>(urlPath, {
        query,
        init: {
          method: 'PUT',
          body: requestData,
        },
      });
    },
    ...queryOptions,
    mutationKey: ['import_historical_work'],
  });
};
